"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATOR_TYPE_ENUM = exports.OPERAND_TYPE_ENUM = exports.IndicatorEnum = void 0;
var fp_1 = require("lodash/fp");
var IndicatorEnum;
(function (IndicatorEnum) {
    IndicatorEnum["Price"] = "PRICE";
    IndicatorEnum["Rsi"] = "RSI";
    IndicatorEnum["Ma50"] = "MA_50";
    IndicatorEnum["Ma200"] = "MA_200";
    IndicatorEnum["Vwap"] = "VWAP";
    IndicatorEnum["Macd"] = "MACD";
    IndicatorEnum["MacdSignal"] = "MACD_SIGNAL";
    IndicatorEnum["PricePercentageChange1Day"] = "PRICE_PERCENTAGE_CHANGE_1_DAY";
    IndicatorEnum["PricePercentageChange5Days"] = "PRICE_PERCENTAGE_CHANGE_5_DAYS";
    IndicatorEnum["Ema9"] = "EMA_9";
    IndicatorEnum["Ema20"] = "EMA_20";
    IndicatorEnum["Ema55"] = "EMA_55";
    IndicatorEnum["Ema89"] = "EMA_89";
    IndicatorEnum["UpperBollingerBand"] = "UPPER_BOLLINGER_BAND";
    IndicatorEnum["LowerBollingerBand"] = "LOWER_BOLLINGER_BAND";
    IndicatorEnum["RedditMentionsLast60Mins"] = "REDDIT_MENTIONS_60_MINS";
    IndicatorEnum["AveragePrice"] = "AVERAGE_PRICE";
})(IndicatorEnum = exports.IndicatorEnum || (exports.IndicatorEnum = {}));
exports.OPERAND_TYPE_ENUM = fp_1.concat(Object.values(IndicatorEnum), ['CONSTANT_THRESHOLD']);
exports.OPERATOR_TYPE_ENUM = [
    'CROSSES_ABOVE',
    'CROSSES_BELOW',
    'IS_ABOVE',
    'IS_BELOW'
];
